export function init_add_cart_modal(){

  var $ = jQuery;
  var messagesString = '';
  var $confirmationModal = null;

  $(document).on('click.dzswtl-add-to-cart-modal','.dzswtl-table-item-button a[href*="?add-to-cart"],.dzswtl-table-item-button a[href*="&add-to-cart"]', handleMouse);
  $(document).on('mouseover.dzswtl-add-to-cart-modal','.messages-stack', handleMouse);
  $(document).on('mouseout.dzswtl-add-to-cart-modal','.messages-stack', handleMouse);
  $(document).on('submit.dzswtl-add-to-cart-modal','.dzswtl--purchase-lightbox--form', handleSubmit);
  $(document).on('submit.dzswtl','.add-to-cart-form', handleSubmit);





  if($('.dzswtl-confirmation-modal').length){
    $confirmationModal = $('.dzswtl-confirmation-modal').eq(0);
  }else{
    initConfirmationModal();
  }
  function initConfirmationModal(){
    $('body').append('<div class="dzswtl-confirmation-modal" style=""> <div class="messages-stack" style=""></div></div>');

    $confirmationModal = $('.dzswtl-confirmation-modal').eq(0);
  }

  function modalOpen(){

    $confirmationModal.find('.messages-stack').addClass('confirmation-activated');
  }
  function modalClose(){


    // -- do not close on hover
    if($confirmationModal.find('.messages-stack').hasClass('hovered')){
      setTimeout(modalClose, 1000);
    }else{

      $confirmationModal.find('.messages-stack').removeClass('confirmation-activated');
    }
  }

  function addToCartInModal(href, $t){

    $t.find('button').prop('disabled',true);

    $.ajax({
      async: "true",
      method: "GET",
      url: href,
      dataType: 'html',
      success: function (response) {

        $t.removeClass('dzswtl-button-disabled');

        // coming from woocommerce todo: add custom / refresh cart
        var getMessagesRegexr = /<div class="woocommerce-message[\s|\S]*?<\/div>/g

        var foundAddToCartConfirmationMessages = getMessagesRegexr.exec(response);


        messagesString = '';
        if(foundAddToCartConfirmationMessages && foundAddToCartConfirmationMessages[0]){
          Object.keys(foundAddToCartConfirmationMessages).forEach(key=>{
            if(isNaN(Number(key))===false){
              messagesString+=foundAddToCartConfirmationMessages[key];
            }
          })
        }

        $confirmationModal.find('.messages-stack').html(messagesString);
        modalOpen();
        setTimeout(modalClose, 4000);
        $t.find('button').prop('disabled',false );

      },

    });
    return false;
  }


  function handleSubmit(e){

    var $t = $(this);

    if(e.type==='submit'){
      const $form = $t;
      addToCartInModal(add_query_arg(window.location.href, 'add-to-cart', $form.find('input[name="add-to-cart"]').val() ), $t);
      setTimeout(()=>{
        if(window.close_ultibox){

          close_ultibox();
        }else{
          console.log('[warning] no ultibox')
        }
      },300);
      return false;
    }
  }

  function handleMouse(e) {

    var _t = $(this);

    if (e.type === 'click') {

      _t.addClass('dzswtl-button-disabled');
      addToCartInModal(_t.attr('href'), _t);
      if (e.type === 'mouseover') {

        _t.addClass('hovered');
      }
      if (e.type === 'mouseout') {

        _t.removeClass('hovered');
      }

    }
  }
}